import type { LexicalEditor } from 'lexical';

import { registerNodeTracking } from '../../utils/registerNodeTracking';
import { $isDynamicDataNode, DynamicDataNode } from './DynamicDataNode';

type Callbacks = {
  onAdded: (key: string) => void;
  onRemoved: (key: string) => void;
};

/**
 * Reports a placeholder key's first chip appearing and its last one going, for local edits (undo included).
 * - Lets the host delete definitions no longer used, and restore them when an undo brings the chip back.
 */
export const registerDynamicDataTracking = (editor: LexicalEditor, callbacks: Callbacks): (() => void) =>
  registerNodeTracking(
    editor,
    DynamicDataNode,
    (node) => ($isDynamicDataNode(node) ? node.getId() : null),
    (key) => key,
    callbacks,
  );
